import React from 'react';
import { CardMedia, Box, Typography } from '@material-ui/core';
import { Link } from 'gatsby-theme-material-ui';

import { useTranslation } from 'react-i18next';
import SEO from '../components/seo';
import { RegistrationForm } from '../components/Auth';
import { Header, Content } from '../components/layouts';
import logoPath from '../images/logo.png';

const Register = () => {
  const { t } = useTranslation();
  return (
    <>
      <SEO title="Register Merchant" />
      <Header noMenu backArrow />
      <Content md={4} alignMiddle>
        <Box pb={2} align="center">
          <Link to="/">
            <CardMedia
              src={logoPath}
              component="img"
              alt="Pintuna logo"
              style={{ width: '200px' }}
            />
          </Link>
        </Box>
        <Box py={2}>
          <Typography variant="body2" color="textSecondary">
            {t('registerWithPintuna')}
          </Typography>
        </Box>
        <RegistrationForm />
        <Box py={2}>
          <Typography variant="body2" color="textSecondary">
            By creating an account, you agree to Pintuna&apos;s{' '}
            <Link
              to="https://pintuna.com/terms-of-use/"
              color="#0645AD"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Use{' '}
            </Link>{' '}
            and{' '}
            <Link
              to="https://pintuna.com/privacy-policy/"
              color="#0645AD"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </Link>
            .
          </Typography>
        </Box>
      </Content>
    </>
  );
};

export default Register;
